$(document).ready(function () {



    var productId   = $('.product-personalizer').data('id');

    if(productId != '4770811773064')
        return;
  
  
  var s = document.createElement("script");
  s.type = "text/javascript";
  s.src = "//doshopify.com/product-personalizer/canvas-script.php?shop=y-oung-hustle.myshopify.com&prid=5313902674082";
  $("head").append(s);

    var checkInterval = setInterval(function () {

        if($('.zoom-product').length && $('textarea.pplr_text').length ) { //&& $('.zoomWindowContainer div').length
            clearInterval( checkInterval );
            startBind();
        }

    },2000);

    function startBind() {

        var $textarea = $('textarea.pplr_text');
        var $previewButton = $('<a href="#" title="Vorschau anzeigen" class="show-preview">Vorschau anzeigen</a>');

        if( $textarea.length ) {

            if( ! $('.show-preview').length ) {
                $textarea.parent().append( $previewButton );
            }

        }

        $('.show-preview').unbind('click');



        $previewButton.click(function(e) {

            $('.zoom-product').css('opacity',0.5);
            $('.pt-mobile-product-slider').css('opacity',0.5);

            var val         = $textarea.val();

            if(productId != '4770811773064')
                return;

            $.post('https://yng-hstl-01.kerngebiet.digital/?name='+val+'&productId='+productId+'&preview=1&multiPreview=1', function() {

            },"json").done(function (result) {

                if(result['preview_1']) {

                    setPreview( result['preview_1'] , 0 );
                    setPreview( result['preview_2'] , 1 );
                    setPreview( result['preview_3'] , 2 );




                    //$('.zoomWindowContainer div').css('background-image', 'url('+result+')');
                    //$('.zoom-product').attr('src',result);
                    //$('.pt-mobile-product-slider .slick-current img').attr('srcset',result);
                    //$('.pt-mobile-product-slider .slick-current img').attr('src',result);


                    if($(window).width() < 480) {
                        $('html, body').animate({
                            scrollTop: $("#shopify-section-product-template").offset().top
                        }, 1000);
                    }
                }


            }).always(function () {
                $('.zoom-product').css('opacity',1);
                $('.pt-mobile-product-slider').css('opacity',1);
            });

        });
    }

    function setPreview(previewImage, index) {

        var $desktopSlideThumbnail = $('#smallGallery [data-slick-index="'+index+'"]');
        var $desktopSlideThumbnailA = $('#smallGallery [data-slick-index="'+index+'"]').find('a');
        var $mobileSlideThumbnail = $('.pt-mobile-product-slider [data-slick-index="'+index+'"]');
      
      //console.dir($desktopSlideThumbnailA);

        //Desktop ändern:
        $desktopSlideThumbnail.attr( 'data-image' , previewImage);
        $desktopSlideThumbnail.attr( 'data-zoom-image' , previewImage);

        //$desktopSlideThumbnailA.attr( 'data-image' , previewImage);
        //$desktopSlideThumbnailA.attr( 'data-zoom-image' , previewImage);

        $desktopSlideThumbnailA.data( 'image' , previewImage);
        $desktopSlideThumbnailA.data( 'zoom-image' , previewImage);
      
        $desktopSlideThumbnailA.attr( 'data-image' , previewImage);
        $desktopSlideThumbnailA.attr( 'data-zoom-image' , previewImage);

        //Mobile ändern:
        $mobileSlideThumbnail.find('img').attr('srcset' , previewImage );
        $mobileSlideThumbnail.find('img').attr('src' , previewImage );

        //Vorschaubild Desktop:
        if( $desktopSlideThumbnail.find('a').hasClass('zoomGalleryActive') ) {
            //$('.zoomWindowContainer div').css('background-image', 'url('+previewImage+')');
            $('.zoom-product').attr('src',previewImage);
        }

    }


});
